import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { API_BASE_URL } from '../config/apiConfig';

const PerfectFitGuarantee = () => {
  const [page, setPage] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/pages/Perfect%20Fit`);
        const data = await res.json();
        setPage(data);
      } catch (error) {
        console.error("Failed to load Perfect Fit Guarantee page:", error);
      }
    };

    fetchPage();
  }, []);

  return (
    <>
      <Header />
      <main className="rbt-main-wrapper">
        <div className="rbt-putchase-guide-area breadcrumb-style-max-width rbt-section-gapTop rbt-section-gapBottom">
          <div className="rbt-article-content-wrapper">
            <div className="content">
              <h4 style={{ fontSize: '48px' }}>{page?.title || "Perfect Fit Guarantee"}</h4>
              <div className="rich-html-wrapper">
                <div
                  className="rich-html-inner"
                  dangerouslySetInnerHTML={{ __html: page?.htmlContent || "<p>Loading...</p>" }}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </main>

      <div className="rbt-progress-parent">
        <svg className="rbt-back-circle svg-inner" width="100%" height="100%" viewBox="-1 -1 102 102">
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
    </>
  );
};

export default PerfectFitGuarantee;
